import 'core-js/stable'
import 'regenerator-runtime/runtime'
import * as $ from 'jquery'
import 'lazysizes'
import '../../src/util/install_sentry'

import './site_common'

import 'Components/refosumu/basics/breadcrumb/component'
import 'Components/refosumu/company_link_header/component'
import 'Components/refosumu/review_card_list/component'
import 'Components/refosumu/company_info/component'
import 'Components/refosumu/call_to_action_button/component'
import 'Components/refosumu/call_to_action_link/component'
import 'Components/refosumu/v2/floating/component'

import spToggleNav from '../../src/spToggleNav/spToggleNav'
$(() => {
  spToggleNav()
})
